<template>
  <div>
    <form @submit.prevent="validateBeforeSubmit()">
      <v-card-title style="padding: 0px">
        <v-layout justify-center row wrap>
          <v-flex xs5>
            <v-layout row justify-center wrap>
              <v-flex xs12 pa-2>
                <v-text-field
                  v-model="form.old_password"
                  :label="$t('Current password')"
                  name="old_password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  @click:append="showPassword = !showPassword"
                  background-color="gray"
                  v-validate="'required|min:6'"
                  :error="errors.has('old_password')"
                  box
                  hide-details
                  autocomplete="off"
                  prepend-inner-icon="lock"
                />
              </v-flex>
              <v-flex xs12 pa-2>
                <v-text-field
                  v-model="form.new_password"
                  :label="$t('New password')"
                  name="new_password"
                  :type="showPassword ? 'text' : 'password'"
                  background-color="gray"
                  v-validate="'required|min:6'"
                  :error="errors.has('new_password')"
                  box
                  hide-details
                  autocomplete="off"
                  prepend-inner-icon="lock"
                  ref="password"
                />
              </v-flex>
              <v-flex xs12 pa-2>
                <v-text-field
                  v-model="form.new_password_confirmation"
                  :label="$t('Confirm password')"
                  name="new_password_confirmation"
                  :type="showPassword ? 'text' : 'password'"
                  background-color="gray"
                  v-validate="'required|min:6|confirmed:password'"
                  :error="errors.has('new_password_confirmation')"
                  box
                  hide-details
                  autocomplete="off"
                  prepend-inner-icon="lock"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-divider light />

      <v-card-actions>
        <v-layout column>
          <v-flex xs12 class="pb-2 px-2" style="color: #444;"
            >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
          >

          <v-layout justify-end ma-2>
            <v-btn type="submit" color="success" :loading="btnUpdateLoading">
              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
              {{ $t('Update') }}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card-actions>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      form: {},
      showPassword: false,
      btnUpdateLoading: false
    }
  },

  computed: {
    ...mapGetters({
      authUserData: 'auth/getAuthUserData'
    })
  },

  methods: {
    ...mapActions({
      setErrorsList: 'errors/setErrorsList',
      resetAllErrors: 'errors/resetAllErrors',
      changePassword: 'staff/changePassword'
    }),

    validateBeforeSubmit() {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData()
            formData.append('old_password', this.form.old_password)
            formData.append('new_password', this.form.new_password)
            formData.append('lang', this.authUserData.lang)
            formData.append('new_password_confirmation', this.form.new_password_confirmation)
            let payload = { id: this.authUserData.user_id, formData }
            this.changePassword(payload)
              .then(() => {
                this.form = {}
                this.btnUpdateLoading = false
                this.resetAllErrors(true)
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped />
